'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styled = require('../styled');

var _styled2 = _interopRequireDefault(_styled);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _MobileMenuList = require('./MobileMenuList');

var _MobileMenuList2 = _interopRequireDefault(_MobileMenuList);

var _reactRouter = require('react-router');

var _Menu = require('../../../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _place = require('../../../../constants/place');

var _place2 = _interopRequireDefault(_place);

var _urlLocations = require('../../../../routes/urlLocations');

var _NotificationBadge = require('../NotificationBadge');

var _NotificationBadge2 = _interopRequireDefault(_NotificationBadge);

var _isSp = require('../../../../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var desktopMinWidth = 1097;
var Menu = (0, _Menu2.default)({
  place: _place2.default.Header,
  isSp: _isSp.isSp
});
var iconStyles = {
  color: (0, _isSp.isSp)() ? '#1A1A1A' : '#B5C3CA'
};

var MobileMenu =
/*#__PURE__*/
function (_react$Component) {
  _inherits(MobileMenu, _react$Component);

  function MobileMenu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MobileMenu);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MobileMenu)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      isOpen: false
    }, _this.setMenuStatus = function () {
      var setMobileMenuStatus = _this.props.setMobileMenuStatus;

      if (window.innerWidth > desktopMinWidth) {
        _this.setState(function () {
          return {
            isOpen: false
          };
        });

        setMobileMenuStatus(false);
      }
    }, _this.onBurgerClick = function () {
      var setMobileMenuStatus = _this.props.setMobileMenuStatus;

      _this.setState(function () {
        return {
          isOpen: !_this.state.isOpen
        };
      });

      setMobileMenuStatus(!_this.state.isOpen);
    }, _temp));
  }

  _createClass(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', (0, _debounce2.default)(this.setMenuStatus));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          pathname = _this$props.location.pathname,
          setMobileMenuStatus = _this$props.setMobileMenuStatus;

      if (nextProps.location.pathname !== pathname) {
        this.setState({
          isOpen: false
        });
        setMobileMenuStatus(false);
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setMenuStatus);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          setMobileMenuStatus = _this$props2.setMobileMenuStatus,
          userType = _this$props2.userType,
          isAdminPlatform = _this$props2.isAdminPlatform,
          userTheme = _this$props2.userTheme,
          unread = _this$props2.unread,
          spPlatformConfig = _this$props2.spPlatformConfig,
          setLogoutModalVisible = _this$props2.setLogoutModalVisible,
          user = _this$props2.user,
          sidebarComponent = _this$props2.sidebarComponent;
      var isOpen = this.state.isOpen;
      var isSpCheck = (0, _isSp.isSp)();
      var accentColor = spPlatformConfig ? spPlatformConfig.accentColor : '#1496af';
      return _react2.default.createElement(_styled2.default.MobileMenu, null, _react2.default.createElement(_styled2.default.NotificationBurgerMenu, null, _react2.default.createElement(Menu.Item, {
        key: 'notifications'
      }, _react2.default.createElement(Menu.NavLink, {
        to: _urlLocations.notifications
      }, _react2.default.createElement(_NotificationBadge2.default, {
        count: unread,
        iconStyles: iconStyles
      }))), _react2.default.createElement(_styled2.default.MobileMenuBurgerWrapper, {
        isOpen: isOpen,
        onClick: this.onBurgerClick
      }, _react2.default.createElement(_styled2.default.MobileMenuBurger, {
        userTheme: userTheme,
        isOpen: isOpen
      }))), _react2.default.createElement(_styled2.default.MobileMenuList, {
        userTheme: userTheme,
        isOpen: isOpen,
        isSpCheck: isSpCheck,
        accentColor: accentColor
      }, _react2.default.createElement(_styled2.default.MobileMenuListWrap, {
        isSpCheck: isSpCheck,
        accentColor: accentColor
      }, _react2.default.createElement(_MobileMenuList2.default, {
        sidebarComponent: sidebarComponent,
        userType: userType,
        userTheme: userTheme,
        user: user,
        unread: unread,
        setLogoutModalVisible: setLogoutModalVisible,
        spPlatformConfig: spPlatformConfig,
        onBurgerClick: this.onBurgerClick
      }))));
    }
  }]);

  return MobileMenu;
}(_react.Component);

exports.default = (0, _reactRouter.withRouter)(MobileMenu);